module.exports = __webpack_public_path__ + "img/P30-en.b0960cec.png";